export const Channel = `
  Complete your channel information.
`

export const Demos = `
  You still have some demos that are unlabeled.
`

export const Playbooks = `
  Select published classes in order to make a playbook. Playbooks are similar to song playlists. They are a list of classes.
`

export const Settings = `
  You must connect your srtipe account to complete your trainer setup.
`

export const Published_Classes = `
  Go to your class library to see all of your published classes.
`

export const Exercise = `
  Go to your exercise library to see your finished exercises.
`

export const Unlabeled_Exercise = `
  Label your exercise video demonstrations in order to create new exercises for your library. Upload new exercise demonstrations videos here as well.
`

export const Templates = `
  Go to templates in order to create a class template to make creating classes faster and easier.
`

export const Incomplete_Exercises = `
  Fill out more information about your exercise to make it complete.
`

export const Unpublished_Classes = `
  Complete your class to publish it.
`